export default function Hero() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden bg-background-50">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/40 via-background-50 to-accent-50/30"></div>

      <div className="relative w-full px-4 md:px-6 py-28 md:py-32">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>全网热门影视免费在线观看</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-4">
              蘑菇影院
              <span className="block text-primary-500 mt-1">免费高清不缓冲</span>
            </h1>

            <p className="text-foreground-500 text-base md:text-lg leading-relaxed max-w-xl mb-8">
              蘑菇影院为您提供海量免费电影在线观看和免费电视剧全集资源，涵盖动作片、喜剧片、爱情片、科幻片、悬疑片等多种类型。全网最新热门影视每日同步更新，高清画质流畅播放不缓冲，让您足不出户享受影院级免费在线观看体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-vidicon-line"></i>
                </span>
                <span>每日更新 <strong className="text-foreground-800 font-semibold">50+</strong> 部影片</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-hd-line"></i>
                </span>
                <span>全站 <strong className="text-foreground-800 font-semibold">1080P</strong> 高清画质</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-shield-check-line"></i>
                </span>
                <span>无需注册 <strong className="text-foreground-800 font-semibold">即点即看</strong></span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => handleScrollTo(e, '#cards')}
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始免费观影
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScrollTo(e, '#ranking')}
                className="inline-flex items-center gap-2 px-7 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 font-medium text-sm rounded-lg border border-background-200/70 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热播榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20composition%20with%20warm%20golden%20spotlight%20illuminating%20a%20classic%20movie%20theater%20interior%2C%20velvet%20red%20curtains%20framing%20the%20scene%2C%20floating%20film%20strips%20and%20soft%20bokeh%20lights%2C%20elegant%20and%20artistic%20atmosphere%2C%20rich%20contrast%20with%20deep%20shadows%2C%20cinematic%20lighting%20with%20lens%20flares%2C%20warm%20amber%20and%20cream%20tones%2C%20no%20text%2C%20no%20people&width=800&height=600&seq=hero-cinema-2026&orientation=landscape"
                  alt="蘑菇影院 - 沉浸式观影体验"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-accent-500 rounded-2xl flex items-center justify-center">
                <span className="text-background-50 font-bold text-2xl font-heading">🍿</span>
              </div>
              <div className="absolute -top-3 -left-3 w-16 h-16 bg-primary-500/90 rounded-xl flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-background-50"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}